function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m0.44624 20.09c0-10.778 8.7498-19.527 19.527-19.527 10.815 0 19.527 8.7498 19.527 19.527 0 10.815-8.7123 19.527-19.527 19.527-10.778 0-19.527-8.7123-19.527-19.527z",
  fill: "#fff",
  fillRule: "evenodd"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "icon-tertiary",
  d: "m0.44624 20.09c0-10.778 8.7498-19.527 19.527-19.527 10.815 0 19.527 8.7498 19.527 19.527 0 10.815-8.7123 19.527-19.527 19.527-10.778 0-19.527-8.7123-19.527-19.527",
  fill: "none",
  stroke: "#002060",
  strokeMiterlimit: 9
});
var _ref4 = /*#__PURE__*/React.createElement("g", {
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}, React.createElement("path", {
  d: "m4.4682 11.946c0-0.16329 0.1323-0.29574 0.2954-0.29574h9.3815c0.1631 0 0.2954 0.13245 0.2954 0.29574v1.1834c0 0.16329-0.1323 0.29574-0.2954 0.29574h-9.3815c-0.1631 0-0.2954-0.13245-0.2954-0.29574z"
}), React.createElement("path", {
  d: "m4.4682 16.383c0-0.16329 0.1323-0.29574 0.2954-0.29574h9.3815c0.1631 0 0.2954 0.13245 0.2954 0.29574v1.1834c0 0.16329-0.1323 0.29574-0.2954 0.29574h-9.3815c-0.1631 0-0.2954-0.13245-0.2954-0.29574z"
}), React.createElement("path", {
  d: "m4.4682 20.82c0-0.16329 0.1323-0.29574 0.2954-0.29574h9.3815c0.1631 0 0.2954 0.13245 0.2954 0.29574v1.1834c0 0.16329-0.1323 0.29574-0.2954 0.29574h-9.3815c-0.1631 0-0.2954-0.13245-0.2954-0.29574z"
}), React.createElement("path", {
  d: "m4.4682 25.257c0-0.16329 0.1323-0.29574 0.2954-0.29574h9.3815c0.1631 0 0.2954 0.13245 0.2954 0.29574v1.1834c0 0.16329-0.1323 0.29574-0.2954 0.29574h-9.3815c-0.1631 0-0.2954-0.13245-0.2954-0.29574z"
}));
var _ref5 = /*#__PURE__*/React.createElement("g", {
  className: "icon-primary",
  transform: "matrix(.21522 0 0 .21329 4.5774 10.48)",
  fill: "#ecaec6",
  strokeMiterlimit: 8,
  strokeWidth: 4.6673
}, React.createElement("rect", {
  x: 60.5,
  y: 63.5,
  width: 21,
  height: 20
}), React.createElement("rect", {
  x: 81.5,
  y: 21.5,
  width: 21,
  height: 21
}), React.createElement("rect", {
  x: 102.5,
  y: 42.5,
  width: 20,
  height: 21
}), React.createElement("rect", {
  x: 122.5,
  y: 42.5,
  width: 21,
  height: 21
}));
var _ref6 = /*#__PURE__*/React.createElement("g", {
  className: "icon-secondary",
  transform: "matrix(.21634 0 0 .21329 4.5095 10.308)",
  fill: "#adb9ca",
  strokeMiterlimit: 8,
  strokeWidth: 4.6551
}, React.createElement("rect", {
  x: 60.5,
  y: 1.5,
  width: 21,
  height: 20
}), React.createElement("rect", {
  x: 81.5,
  y: 42.5,
  width: 21,
  height: 21
}), React.createElement("rect", {
  x: 102.5,
  y: 1.5,
  width: 20,
  height: 20
}), React.createElement("rect", {
  x: 122.5,
  y: 21.5,
  width: 21,
  height: 21
}));
var _ref7 = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.55888 0 0 .55436 2.7724 9.2197)",
  fill: "none",
  stroke: "#002060"
}, React.createElement("rect", {
  className: "icon-tertiary",
  x: 26.533,
  y: 2.4574,
  width: 32.041,
  height: 32.088,
  strokeMiterlimit: 8,
  strokeWidth: 1.7966
}), React.createElement("g", {
  strokeWidth: "1.7966px"
}, React.createElement("path", {
  className: "icon-tertiary",
  d: "m26.625 10.5h32"
}), React.createElement("path", {
  className: "icon-tertiary",
  d: "m26.604 26.542h32.083"
}), React.createElement("path", {
  className: "icon-tertiary",
  d: "m26.354 18.542h32.167"
}), React.createElement("path", {
  className: "icon-tertiary",
  d: "m34.583 2.3542v32.333"
}), React.createElement("path", {
  className: "icon-tertiary",
  d: "m42.542 2.2917v32.333"
}), React.createElement("path", {
  className: "icon-tertiary",
  d: "m50.542 2.25v32.333"
})));
var SvgMenuHeatmapIcon = function SvgMenuHeatmapIcon(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, ["svgRef"]);
  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMenuHeatmapIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/menu-heatmap-icon.6568c239.svg";
export { ForwardRef as ReactComponent };